const jury = {
  namespaced: true,
  state: {
    assignments: [],
    activeApp: {
      i: 0,
      svId: null,
      scoreId: null,
      essay1Content: '',
      essay2Content: '',
      essay3Content: '',
      essay1Score: null,
      essay2Score: null,
      essay3Score: null,
      overall: null,
      red_flag: 0,
      red_flag_reasons: ''
    }
  },
  mutations: {
    setAssignments (state, assignments) {
      state.assignments = assignments
    },
    setActiveApp (state, { svId, essay1Content, essay2Content, essay3Content }) {
      let app = state.assignments.find(assignment => {
        return assignment.student_volunteer_id === svId
      })
      state.activeApp.i = state.assignments.findIndex(assign => {
        return assign.student_volunteer_id === svId
      }) + 1

      state.activeApp.essay1Content = essay1Content
      state.activeApp.essay2Content = essay2Content
      state.activeApp.essay3Content = essay3Content
      state.activeApp.essay1Score = app.essay1
      state.activeApp.essay2Score = app.essay2
      state.activeApp.essay3Score = app.essay3
      state.activeApp.overall = app.overall
      state.activeApp.red_flag = app.red_flag || 0
      state.activeApp.red_flag_reasons = app.red_flag_reasons
      state.activeApp.scoreId = app.score_id
      state.activeApp.svId = svId
    },
    updateAssignmentListScores (state, scoreId) {
      state.assignments[state.activeApp.i - 1].essay1 = state.activeApp.essay1Score
      state.assignments[state.activeApp.i - 1].essay2 = state.activeApp.essay2Score
      state.assignments[state.activeApp.i - 1].essay3 = state.activeApp.essay3Score
      state.assignments[state.activeApp.i - 1].overall = state.activeApp.overall
      state.assignments[state.activeApp.i - 1].red_flag = state.activeApp.red_flag
      state.assignments[state.activeApp.i - 1].red_flag_reasons = state.activeApp.red_flag_reasons
      state.assignments[state.activeApp.i - 1].score_id = scoreId
      state.activeApp.scoreId = scoreId
    }
  },
  getters: {
    listAssignments: (state) => {
      return state.assignments.map((assignment, index) => {
        assignment.i = index + 1
        assignment.isScored = assignment.score_id !== null
        return assignment
      })
    }
  },
  actions: {
    getTLAssignments ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'jury/tl-assignments/' + rootState.user.profile.id, {
          headers: {
            'Authorization': rootState.user.session.accessToken
          }
        }).then(response => {
          return response.json().then(payload => {
            if (response.status === 200 && payload.success) {
              commit('setAssignments', payload.data.assignments)
              resolve()
            } else {
              commit('error', { message: payload.data.message }, { root: true })
              resolve()
            }
          })
        }).catch(err => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    setActiveApp ({ commit, rootState }, svId) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'application/' + svId,
          {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          })
          .then(response => {
            return response.json().then(payload => {
              if (response.status === 200 && payload.success) {
                commit('setActiveApp', {
                  svId: payload.data.student_volunteer_id,
                  essay1Content: payload.data.data.essay1,
                  essay2Content: payload.data.data.essay2,
                  essay3Content: payload.data.data.essay3
                })
                resolve()
              } else {
                commit('error', { message: 'Unable to load application' }, { root: true })
                resolve()
              }
            })
          }).catch(err => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
      })
    },
    saveScores ({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        let path = 'jury/score'
        if (state.activeApp.scoreId !== null) {
          path += '/' + state.activeApp.scoreId
        }
        fetch(process.env.BASE_URL + path, {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: JSON.stringify({
            tl_id: rootState.user.profile.id,
            sv_id: state.activeApp.svId,
            essay1: state.activeApp.essay1Score,
            essay2: state.activeApp.essay2Score,
            essay3: state.activeApp.essay3Score,
            overall: state.activeApp.overall,
            red_flag: state.activeApp.red_flag,
            red_flag_reasons: state.activeApp.red_flag_reasons
          })
        }).then(response => {
          return response.json().then(payload => {
            if (response.status === 200 && payload.success === true) {
              let scoreId = state.activeApp.scoreId
              if (scoreId === null) {
                scoreId = payload.data.score.score_id
              }
              commit('updateAssignmentListScores', scoreId)
              resolve()
            } else {
              commit('error', { message: payload.data.message }, { root: true })
              reject(payload.data.error)
            }
          })
        }).catch(err => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    }
  }
}

export default jury



// WEBPACK FOOTER //
// ./src/store/jury.js